module.exports = __webpack_public_path__ + "media/pro.9ea27905.mp4";